





































































































import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/DataTable.scss';
import { Action } from '../types/event';
import '../assets/css/ConfirmationBox.scss';
import { MedTransGoConstants } from '../util/constants';
import Badge from '../components/Badge.vue';
@Component({
       components: {
        Badge,
    },
    props: {
        dataSource: Object,
        busy: Boolean,
        showStatusPils: Boolean,
    },
})
export default class DataTable extends Vue {
    private confirmEvent: any = null;
    private searchString: string = '';
    private paginationLimit = MedTransGoConstants.PAGINATION_LIMIT;
    // private page = this.$props.dataSource.page || 1;

    public mounted() {
        this.$props.dataSource.page = 1;
    }

    private handleFilter(actions: Action[], actionData: any) {
        // this.page = 1;
        this.handleActions(actions, actionData);
    }

    private getFields(columns: Array<{ label: string; fieldName: string; template?: any }>) {
        const fields: Array<{ key: string, label: string, template?: any }> = [];
        columns.forEach((column) => {
            fields.push({ key: column.fieldName, label: column.label, template:  column.template});
        });
        if (this.$props.dataSource.actions) {
            fields.push({ key: 'actions', label: 'Actions' });
        }
        return fields;
    }

    private handleActions(actions: Action[], actionData: any) {
        actions.forEach((action: Action) => {
            const type = action.type;
            switch (type) {
                case 'Event':
                    if (action.eventData) {
                        action.eventData.data = actionData;
                        this.$root.$emit(action.eventName, action.eventData);
                    } else {
                        this.$emit(action.eventName, actionData);
                    }
                    break;
                case 'Confirm':
                    this.confirmEvent = action;
                    this.confirmEvent.eventData.data = actionData;
                    break;
            }
        });
    }

    // const patient = {address: {fullAddress: 'Pune'},fullName: 'XXXTTT'};
    // const value 1 = resolveObjectFieldPath(patient,'address.fullAddress'); ==> 'Pune'
    // const value 2 = resolveObjectFieldPath(patient,'fullName'); ==> 'XXXTTT'
    private resolveObjectFieldPath(obj: any, path: string) {
        const paths = path.split('.');
        let current = obj;
        paths.forEach((value) => {
            if (current[value] === undefined) {
                return undefined;
            } else {
                current = current[value];
            }
        });
        return current;
    }

    private handleConfirm() {
        this.handleActions(this.confirmEvent.actions, this.confirmEvent.eventData.data);
        this.confirmEvent = null;
    }

    private handleSearch(actions: Action[], event: any) {
        if (event.keyCode === 13) {
            // this.page = 1;
            this.handleActions(actions, this.searchString);
        }
    }

    private getNextRecords(selectedPage: number) {
        this.$emit(MedTransGoConstants.EVENT_PAGE_CHANGE, this.searchString, this.paginationLimit *
            (selectedPage - 1));
    }

    private verifyConditions(element: any, conditions: string[]) {
        let showAction = false;
        try {
            conditions.forEach((condition: string) => {
                const expression = `element.${condition}`;
                // tslint:disable-next-line: no-eval
                const result = eval(expression);
                if (typeof result === 'boolean') {
                    showAction = result;
                }
            });
        } catch (error) {
            //
        }
        return showAction;
    }
}
